import { render, staticRenderFns } from "./PortalMultipagos.vue?vue&type=template&id=3f85eaca&"
import script from "./PortalMultipagos.vue?vue&type=script&lang=js&"
export * from "./PortalMultipagos.vue?vue&type=script&lang=js&"
import style0 from "./PortalMultipagos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports